import { __decorate } from "tslib";
import { Component, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import baseChart from '@blade-sxp/portrait-center/components/fragments/base-chart.vue';
import { barhOption } from '@blade-sxp/portrait-center/pages/components/line-bars/age-trend/barh-config';
import TimeMixin from '@blade-sxp/portrait-center/components/time-mixin.vue';
import { mixins } from 'vue-class-component';
import { isEmpty } from 'lodash';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import NoData from '@blade-sxp/portrait-center/pages/components/no-data/index.vue';
import { getFuncVisitorTrend } from '@blade-sxp/portrait-center/utils/common-request';
let default_1 = class default_1 extends mixins(TimeMixin) {
    dates;
    zoneType;
    barOption = barhOption(this);
    barSeries = this.barOption.series;
    dataX = [];
    recordMode = 'VISIT_OFFLINE_COUNT';
    isLoading = false;
    isNoData = true;
    timeInterval = '1d'; // 1h & 1d
    timeDateOption = [
        { label: `${this.$t('hour')}`, value: '1h' },
        { label: `${this.$t('day')}`, value: '1d' },
    ];
    get showTimeDate() {
        return this.sourceType === 'VISIT_OFFLINE_COUNT';
    }
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    get sourceType() {
        let value = '';
        if (this.recordMode === 'VISIT_USER_COUNT') {
            if (this.zoneType === 'MAP') {
                value = 'VISIT_USER_COUNT';
            }
            else if (this.zoneType === 'VIRTUAL_AREA') {
                value = 'VA_VISIT_USER_COUNT';
            }
        }
        else if (this.recordMode === 'VISIT_OFFLINE_COUNT') {
            value = 'VISIT_OFFLINE_COUNT';
        }
        return value;
    }
    onUpdateTimeInterval() {
        this.fetchData();
    }
    onChangeDates() {
        this.fetchData();
    }
    onChangeZoneId() {
        this.fetchData();
    }
    mounted() {
        this.fetchData();
    }
    fetchData() {
        // console.log("###", this.zoneType, this.dates)
        this.isNoData = true;
        if (this.zoneId === 0) {
            return false;
        }
        this.reset();
        this.isLoading = true;
        getFuncVisitorTrend({
            businessId: this.zoneId,
            dateStart: this.dates[0],
            dateEnd: this.dates[1],
            attributeType: 'AGE',
            sourceType: this.sourceType,
            zoneType: this.zoneType,
            timeInterval: this.sourceType === 'VISIT_OFFLINE_COUNT' ? this.timeInterval : '',
        })
            .then((res) => {
            this.setData(res);
        })
            .catch((e) => {
            this.$message.error(e.message || `${this.$t('common.serverError')}`);
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    setData(resData) {
        if (isEmpty(resData)) {
            return;
        }
        this.isNoData = false;
        const timeArr = [];
        const elders = [];
        const children = [];
        const adults = [];
        resData.forEach(({ data }) => {
            Object.keys(data).forEach((k) => {
                data[k].forEach((item) => {
                    if (k === 'ST_OLD') {
                        elders.push(item.value || 0);
                        timeArr.push(item.time);
                    }
                    else if (k === 'ST_ADULT') {
                        adults.push(item.value || 0);
                    }
                    else if (k === 'ST_CHILD') {
                        children.push(item.value || 0);
                    }
                });
            });
        });
        this.barOption.xAxis.data = timeArr;
        this.barOption.series[0].data = adults;
        this.barOption.series[1].data = elders;
        this.barOption.series[2].data = children;
        this.barSeries = this.barOption.series;
        this.barOption = { ...this.barOption };
    }
    onModeClick(type) {
        this.recordMode = type;
        this.fetchData();
    }
    reset() {
        this.barOption.xAxis.data = [];
        this.barOption.series[0].data = [];
        this.barOption.series[1].data = [];
        this.barOption.series[2].data = [];
        this.barSeries = this.barOption.series;
        this.barOption = { ...this.barOption };
    }
};
__decorate([
    Prop()
], default_1.prototype, "dates", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneType", void 0);
__decorate([
    Watch('timeInterval')
], default_1.prototype, "onUpdateTimeInterval", null);
__decorate([
    Watch('dates')
], default_1.prototype, "onChangeDates", null);
__decorate([
    Watch('zoneId')
], default_1.prototype, "onChangeZoneId", null);
default_1 = __decorate([
    Component({
        name: 'gender',
        components: { baseChart, 'no-data': NoData },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
